export const playerFactory = () =>
  import(/* webpackChunkName: 'lottie-web' */ "lottie-web");
